export const SearchIcon: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 18 19'
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      d='M13.23 11.487c1.747-2.77 1.416-6.48-.995-8.89C9.44-.2 4.89-.2 2.096 2.596c-2.795 2.794-2.795 7.343 0 10.138 2.408 2.408 6.12 2.738 8.89.995l4.771 4.77L18 16.257zm-2.806-.563a4.615 4.615 0 0 1-6.517 0 4.615 4.615 0 0 1 0-6.517 4.608 4.608 0 1 1 6.518 6.518'
    />
  </svg>
);
